<script setup lang="ts">
import { computed } from 'vue';
import PanelLeftIcon from '@/components/icons/PanelLeftIcon.vue';
import { useSidebar } from '@/components/ui/sidebar';

/**
 * Hides and shows the section sidebar. It sits at the left end of the main
 * area's header row, outside the sidebar, so it is still there to bring the
 * sidebar back once it is hidden. A phone has no section sidebar, so it is
 * hidden there.
 */
const { open, toggleSidebar } = useSidebar();
const label = computed(() => (open.value ? 'Hide sidebar' : 'Show sidebar'));
</script>

<template>
  <button
    type="button"
    :aria-label="label"
    :title="label"
    :aria-expanded="open"
    data-testid="sidebar-toggle"
    class="hidden size-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground md:inline-flex"
    @click="toggleSidebar"
  >
    <PanelLeftIcon class="size-4" />
  </button>
</template>
